import i18next from 'i18next'
import { POSPaymentStatus } from '@/constants'

export const getPOSPaymentStatusName = (status: POSPaymentStatus): string => {
    return status ? i18next.t(`enums:posPaymentStatus.${status}`, { defaultValue: status }) : ''
}
